<template>
  <div class="fill-height">
    <v-card
        height="100%"
        width="100%"
        class="d-flex flex-column rounded-lg"
        flat
    >
      <v-card-title class="text-break"><strong>{{ $t('cards.titles.newsFeed') }}</strong></v-card-title>
      <v-card-text v-if="isLoading" class="d-flex justify-center">
        <v-progress-circular
            color="primary"
            indeterminate
            size="64"
        ></v-progress-circular>
      </v-card-text>
      <v-card-text v-if="!isLoading" class="fill-height py-0">
        <div v-if="!newsfeed.length">{{ $t('cards.texts.noNews') }}</div>
        <v-carousel
            dark
            v-if="newsfeed.length"
            :continuous="true"
            :cycle="true"
            :show-arrows="true"
            hide-delimiters
            show-arrows-on-hover
            next-icon="fal fa-chevron-right"
            prev-icon="fal fa-chevron-left"
            delimiter-icon="fal fa-minus"
            light
            hide-delimiter-background
            :interval="10000"
            height="100%"
        >
          <template v-for="(newsItem, n) in newsfeed">
            <v-carousel-item
                v-if="(n + 1) % columns === 1 || columns === 1"
                :key="'event-slide-' + n"
                eager
            >
              <div class="col-12 ma-0 pa-0 d-flex flex-nowrap">
                <div v-for="(ndx, i) in columns" :key="'column-' + i" class="ma-0 pa-2 py-0" :class="'col-' + (12 / columns)">
                  <template v-if="(n + i) < newsfeed.length">
                    <v-card class="pa-0" tile flat link height="100%" color="transparent" @click.prevent="openItem(newsfeed[i+n])">
                      <v-img
                          v-if="newsfeed[i+n].thumbnail"
                          :src="newsfeed[i+n].thumbnail"
                          lazy-src="/assets/img/placeholder.png"
                          class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                          max-height="300"
                          max-width="100%"
                          cover
                          :aspect-ratio="16/9"
                          eager
                      >
                        <v-chip
                            v-if="newsfeed[i+n].type"
                            class="ma-2 rounded-lg"
                            label
                            small
                            :color="newsfeed[i+n].type === 'event' ? 'secondary' : newsfeed[i+n].type === 'challenge' ? 'accent' : 'info'"
                            style="position: absolute; top: 0; right: 0;"
                        >
                          {{ $t('chips.' + newsfeed[i+n].type) }}
                        </v-chip>
                      </v-img>
                      <v-img
                          v-else
                          src="/assets/img/placeholder.png"
                          lazy-src="/assets/img/placeholder.png"
                          class="grey d-flex justify-start align-end flex-wrap pa-2 rounded-lg overflow-hidden"
                          max-height="300"
                          max-width="100%"
                          cover
                          :aspect-ratio="16/9"
                          eager
                      >
                        <v-chip
                            v-if="newsfeed[i+n].type"
                            class="ma-2 rounded-lg"
                            label
                            small
                            :color="newsfeed[i+n].type === 'event' ? 'secondary' : newsfeed[i+n].type === 'challenge' ? 'accent' : 'info'"
                            style="position: absolute; top: 0; right: 0;"
                        >
                          {{ $t('chips.' + newsfeed[i+n].type) }}
                        </v-chip>
                      </v-img>
                      <v-card-text class="px-0">
                        <div v-if="newsfeed[i+n].title"><strong>{{ newsfeed[i+n].title }}</strong></div>
<!--                        <div v-if="newsfeed[i+n].shortDescription" v-html="newsfeed[i+n].shortDescription"></div>-->
                      </v-card-text>
                    </v-card>
                  </template>
                </div>
              </div>
            </v-carousel-item>
          </template>
        </v-carousel>
      </v-card-text>
    </v-card>

    <!-- NEWS ITEM DIALOG -->
    <v-dialog
        v-model="showItemDialog"
        max-width="600"
        scrollable
    >
      <v-card
          class="rounded-lg d-flex flex-column"
      >
        <v-img
            v-if="selectedItem.image"
            :src="selectedItem.image"
            lazy-src="/assets/img/placeholder.png"
            max-height="400"
        ></v-img>
        <v-img
            v-else
            src="/assets/img/placeholder.png"
            lazy-src="/assets/img/placeholder.png"
            max-height="400"
        ></v-img>
        <v-btn
            class="mt-3"
            color="primary"
            fab
            depressed
            dark
            small
            absolute
            right
            @click.prevent="showItemDialog = false"
        >
          <v-icon small>fal fa-close</v-icon>
        </v-btn>
        <v-card-title v-if="selectedItem.title" class="text-break"><strong>{{ selectedItem.title }}</strong></v-card-title>
        <v-card-text class="fill-height">
          <div v-if="selectedItem.description" v-html="selectedItem.description"></div>
        </v-card-text>
      </v-card>
    </v-dialog>

  </div>
</template>

<script>
import api from "@/api/api";

export default {
  name: "m2h-news-feed",
  data() {
    return {
      isLoading: true,
      newsfeed: [],
      model: null,
      showItemDialog: false,
      selectedItem: {}
    }
  },

  computed: {
    columns() {
      if (this.$vuetify.breakpoint.xl) {
        return 6;
      }

      if (this.$vuetify.breakpoint.lg) {
        return 4;
      }

      if (this.$vuetify.breakpoint.md) {
        return 3;
      }

      if (this.$vuetify.breakpoint.sm) {
        return 2;
      }

      if (this.$vuetify.breakpoint.sm) {
        return 1;
      }

      return 1;
    }
  },
  
  mounted(){
    this.fetchNewsfeed()
  },

  methods: {
    async fetchNewsfeed(){
      this.isLoading = true
      let lang = localStorage.getItem('Lang') || this.$i18n.locale
      let newsfeed = []
      newsfeed = await api.newsItems.getList("newsfeed", lang).then((res) => { return res.data })
      if (newsfeed.length){
        this.newsfeed = newsfeed.sort((a, b) => {
          return this.$moment(a.created).unix() - this.$moment(b.created).unix()
        })
        for (const item of this.newsfeed) {
          let image = await this.fetchImage(item.imageAssetId)
          let thumbnail = await this.fetchImage(item.thumbnailAssetId)
          item.image = image
          item.thumbnail = thumbnail
        }
      }
      this.isLoading = false
    },
    
    async fetchImage(id){
      if (id){
        return await api.newsItems.getSas(id)
            .then((res) => {
              return res.data
            })
            .catch(() => {
              return ''
            })
      } else {
        return ''
      }
    },

    openItem(item){
      this.selectedItem = item
      this.showItemDialog = true
      this.$root.$emit('post-news-opened', { id: item.identifier })
    }
  }
}
</script>

<style scoped>

</style>
